module.exports = __webpack_public_path__ + "img/企业资信.341d0845.jpg";